import { Component, ComponentFactoryResolver, ViewChild } from '@angular/core';
import { ApiService } from 'app/api.service';
import { AppService } from 'app/app.service';
import { Pagination } from 'app/shared/pagination';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';
import { ModalEditEntityComponent, ModalEditEntityDirective } from '../modal-edit-entity/modal-edit-entity.component';

@Component({
	selector: 'modal-select-entity',
	templateUrl: './modal-select-entity.component.html'
})
export class ModalSelectEntityComponent extends UIModalBaseComponent {

	@ViewChild(ModalEditEntityDirective, { static: true }) editEntityHost: ModalEditEntityDirective;

	title = '';
	list: any[] = [];
	search = '';
	pagination = new Pagination();
	mode = 'select';
	po_type = null;
	selected = null;
	isSupplier = false;
	isManufacturer = false;
	showPoCount = false;
	constructor(
		private api: ApiService,
		private app: AppService,
		private factory: ComponentFactoryResolver,
	) {
		super();
	}

	open(mdata: any) {
		this.selected = null;
		this.title = 'Select Entity';
		this.mode = mdata.mode || 'select';
		this.po_type = mdata.po_type || null;
		this.isSupplier = !!mdata.filters.is_supplier;
		this.isManufacturer = !!mdata.filters.is_manufacturer;
		this.showPoCount = !!mdata.show_po_count;
		if (mdata.filters.is_manufacturer) this.title = 'Select Manufacturer';
		if (mdata.filters.is_supplier) this.title = 'Select Supplier';

		this.api.entity.list({ ...mdata.filters, with_po_count: this.showPoCount ? 1 : 0 }, data => {
			this.list = data.list;
		});

		this.modal.open();
	}

	addEntity() {
		// Dynamically create the entity editor to avoid a circular template reference.
		const editorFactory = this.factory.resolveComponentFactory(ModalEditEntityComponent);
		const viewContainerRef = this.editEntityHost.viewContainerRef;
		viewContainerRef.clear();

		const componentRef = viewContainerRef.createComponent<ModalEditEntityComponent>(editorFactory);

		componentRef.instance.close.subscribe(value => {
			// A numeric id means a new entity was saved; fetch it and select it for the parent.
			if (value && value !== 'deleted' && value !== 'restored') {
				this.api.entity.details(value, entity => {
					this.selectItem(entity.details);
				}, error => {
					this.app.notifications.showDanger(error.message);
				});
			}
			componentRef.destroy();
		});

		componentRef.instance.open({
			id: 'new',
			is_supplier: this.isSupplier,
			is_manufacturer: this.isManufacturer,
			supplier_only: this.isSupplier && !this.isManufacturer
		});
	}

	selectItem(item) {
		if(this.mode === 'procure') {
			this.selected = item;
			if(this.po_type) {
				this.selected['po_type'] = this.po_type;
				this.modal.close(this.selected);
			}
		}
		else this.modal.close(item);
	}

	addTo(po_type) {
		this.selected['po_type'] = po_type;
		this.modal.close(this.selected);
	}

}
